<template>
  <div class="home-container">
    <div v-if="user">
      <h1>Welcome to Your Journal App, {{ user.name }}!</h1>
      <p>This application helps you keep track of your daily thoughts and experiences. Navigate to the Journal page to start recording your entries or view the Archive to see past entries.</p>
      <div class="action-buttons">
        <router-link to="/journal" class="button journal">Start Journaling</router-link>
        <router-link to="/archive" class="button archive">View Archive</router-link>
      </div>
    </div>
    <div v-else>
      <h1>Welcome to Our Journal App</h1>
      <p>Join us and explore a new way to document your life. It's quick, easy, and personal.</p>
      <div class="action-buttons">
        <router-link to="/signup" class="button signup">Sign Up</router-link>
        <router-link to="/login" class="button login">Log In</router-link>
      </div>
    </div>
  </div>
</template>

<script>
import { getAuth, onAuthStateChanged } from 'firebase/auth';

export default {
  data() {
    return {
      user: null
    };
  },
  created() {
    const auth = getAuth();
    onAuthStateChanged(auth, (user) => {
      this.user = user ? { name: user.displayName || 'Guest' } : null;
    });
  }
};
</script>

<style scoped>
.home-container {
  max-width: 800px;
  margin: auto;
  padding: 20px;
  text-align: center;
}

h1 {
  color: #333;
  margin-bottom: 20px;
}

p {
  max-width: 600px;
  margin: auto;
  line-height: 1.6;
  color: #666;
}

.action-buttons {
  margin-top: 20px;
}

.button {
  display: inline-block;
  padding: 10px 20px;
  margin: 10px;
  color: white;
  background-color: #5C67F2;
  border-radius: 5px;
  text-decoration: none;
}

.button:hover {
  background-color: #4a54f1;
}

.journal {
  background-color: #34c759; /* Distinct color for journal button */
}

.archive {
  background-color: #34c759; /* Distinct color for archive button */
}

.signup {
  background-color: #ff9500; /* Warm color to attract new users */
}

.login {
  background-color: #007aff; /* Cool color for a calm login experience */
}
</style>
